import { OnInit, Component, ViewChild } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { InabilityService } from '../inability.service';
import { IDtoInabilityFilter } from 'app/shared/models/request/inability/dto-inability-filter.model';
import { IDtoInabilityEmployee } from 'app/shared/models/request/inability/dto-inability-employee.model';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ExcelService } from '../excel.service';
import { IMyDateModel } from 'angular-mydatepicker';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { saveAs } from 'file-saver';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DatePipe } from '@angular/common';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { SecurityService } from 'app/shared/services/security.service';

@Component({
    selector: 'app-inability-records',
    styleUrls: ['inability-records.style.scss'],
    templateUrl: 'inability-records.template.html'
})
export class InabilityRecordsComponent implements OnInit {
    /**Formularios */
    private locale: string = 'es';
    private filters = {} as IDtoInabilityFilter;
    /**Notificaciones */
    private listInabilities: IDtoInabilityEmployee[]
    private listInabilitiesTemp: IDtoInabilityEmployee[]
    private search: string;
    private start: IMyDateModel;
    private end: IMyDateModel;
    private listEmployees: IDtoEmployee[]
    private inabilityEmployee: IDtoInabilityEmployee;
    private showRoles: any;
    private employeeIniId: number;
    private profile: string;
    @ViewChild(DatatableComponent, { static: false }) tableInabilities: DatatableComponent;
    constructor(private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private inabilityService: InabilityService
        , private excelService: ExcelService
        , private datePipe: DatePipe
        , private identityService: IdentityService
        , private securityService: SecurityService) {
            this.showRoles = this.securityService.getUserRolesStorage();
            if (this.showRoles !== '') {
                this.employeeIniId = this.showRoles.employeeId;
            }
    }
    ngOnInit(): void {
        this.profile = this.securityService.getProfileStorage('InabilityRecords');
    }

    private getInabilitiesbyFilters(): void {
        if (this.start == null || this.end == null) {
            this.configGeneral.newToast('Validación', 'Proporcione una fecha de inicio y fin para filtrar', 'warning');
            return;
        }
        this.spinner.show();
        this.filters.startDate = this.getDate(this.start);
        this.filters.endDate = this.getDate(this.end);
        this.filters.employeeId = this.employeeIniId;
        this.filters.profile = this.profile;
        this.inabilityService.getInabilitiesbyFilters(this.filters).subscribe((res) => {
            this.listInabilities = res.data as IDtoInabilityEmployee[];
            this.listInabilitiesTemp = this.listInabilities;
            this.spinner.hide();
        });
    }
    private getDate(event?: IMyDateModel) {
        if (event === undefined) {
            return null;
        }
        return event.singleDate.jsDate;
    }
    generateExcel() {
        if (this.listInabilitiesTemp != undefined) {
            this.excelService.generateExcelInabilities(this.listInabilities);
        }
    }
    private downloadFile(item: IDtoInabilityEmployee): void {
        this.spinner.show();
        if (item.inabilityDocumentId == undefined) {
            return;
        }
        this.inabilityService.downloadFile(item.inabilityDocumentId).subscribe((res) => {
            if (res.isCorrect === true) {
                const file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                saveAs(blob, file.fileDownloadName);
                this.spinner.hide();
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
            }
            
        },
        (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
    }
    private selectItem(item: IDtoInabilityEmployee): void {
        this.inabilityEmployee = item;
    }
    private updateFilter() {
        if (this.search === undefined) {
            return;
        }

        const val = this.search.toLowerCase();
        const temp = this.listInabilitiesTemp.filter((x: any) => x.employeeName.toLowerCase().startsWith(val)
            || x.startDate.toLowerCase().startsWith(val)
            || x.employeeMarkName.toLowerCase().startsWith(val)
            || x.employeeJob.toLowerCase().startsWith(val)
            || x.employeeNum.startsWith(val));
        this.listInabilities = temp;
        this.tableInabilities.offset = 0;
    }
    private handleFileInput(files: FileList) {
        this.upload(files);
    }
    private onFileChange(item: IDtoInabilityEmployee, event) {
        event.value = '';
        this.inabilityEmployee = item;
    }
    private upload(files: FileList): void {
        if (files != undefined) {
            this.spinner.show();
            let document = {} as IDtoDocument;
            const fileName = files.item(0).name;
            let sp = fileName.split('.');
            let fileNameNew = `${this.inabilityEmployee.employeeId}_${this.inabilityEmployee.inabilityId}_AltaMedica_${this.datePipe.transform(this.inabilityEmployee.startDate, 'ddMMyyyy')}.${sp[sp.length - 1]}`;
            document.fileName = fileNameNew;
            document.referenceId = this.inabilityEmployee.inabilityId;
            //document.path = `ST2/${document.fileName}`;
            document.module = 'InabilityRecords';
            document.name = "AltaMedica";
            const file = files.item(0);
            this.inabilityService.uploadFileHospitalDischarge(file, document).subscribe((res) => {
                if (res.isCorrect === true) {
                    this.configGeneral.newToast('Éxito', res.message, 'success');
                    let d = res.data as IDtoDocument;
                    this.addModuleLog(this.inabilityEmployee.inabilityId, 'uploadHospitalDischarge');
                } else {
                    this.configGeneral.newToast('Error', res.message, 'error');
                }
                this.spinner.hide();
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
        }
    }
    private downloadFileHospitalDischarge(item: IDtoInabilityEmployee): void {
        this.spinner.show();
        if (item.inabilityDocumentId == undefined) {
            return;
        }
        this.inabilityService.downloadFileHospitalDischarge(item.inabilityId, 'InabilityRecords', 'AltaMedica').subscribe((res) => {
            if (res.isCorrect === true) {
                const file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                saveAs(blob, file.fileDownloadName);
                this.addModuleLog(item.inabilityId, 'downloadHospitalDischarge');
                this.spinner.hide();
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
            }
        },
        (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Documents';
        dto.module = 'inabilityRecords';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
